export enum AvatarSize {
  sm = "sm",
  md = "md",
  lg = "lg",
}
